export const getAssetType = (url: string): "image" | "video" | "unknown" => {
  if (!url) return "unknown";
  const extension = url.split(".").pop()?.split(/#|\?/)[0].toLowerCase() || "";
  const imageTypes = ["jpg", "jpeg", "png", "gif", "webp", "svg"];
  const videoTypes = ["mp4", "webm", "ogg", "mov", "avi"];

  if (imageTypes.includes(extension)) return "image";
  if (videoTypes.includes(extension)) return "video";
  return "unknown";
};
